export default __webpack_public_path__ + "static/media/thai-flag.0c6aad09.svg";